import React, { useEffect, useState } from "react";
import Silang from './SilangKembangSubComponents/Silang';
import SilangVersiWap from './SilangKembangSubComponents/SilangVersiWap'
import KembangVersiWap from './SilangKembangSubComponents/KembangVersiWap'
import Kembang from './SilangKembangSubComponents/Kembang';
import { useDispatch, useSelector } from "react-redux";
import VersiWAP from "../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo";
import { withTranslation } from "react-i18next";
import { set4dGameSubtype, setCommonConfig } from "../../../../redux/actions";
import MarketClose from "../../SubComponents/MarketClose.js";
import ZeroBalancePopup from "../ZeroBalancePopup";
import GameClosedPopup from "../GameClosedPopup";
import { makeAjax, respStatus, showMessage, url } from "../../../../helpers/global_helper.js";

const SilangKembang = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const game_sub_type = useSelector((state) => state.GameSubType.game_sub_type);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const [subgame12, setSubgame12] = useState();
  const [subgame13, setSubgame13] = useState();
  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: tabIndex == "1" ? "silanghomo" : "kembangkempis" }));
    dispatch(setCommonConfig({ key: 'gameType', value: tabIndex == "1" ? "silanghomo" : "kembangkempis" }))

  };
  useEffect(() => {
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: "SILANG" }));
  }, [])

  useEffect(() => {
    const reqData = { gameId };

    makeAjax(url.TOGEL_API.getSubGameStatus, reqData, url.TOGEL_MS_EXT)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        let resp = response.data;
        const subgame12 = resp.find(sub => sub.subgame_id == 12);
        const subgame13 = resp.find(sub => sub.subgame_id == 13);
        if (subgame12.status === 0) {
          handleTabClick(2);
        } else if (subgame13.status === 0) {
          handleTabClick(1);
        }
        setSubgame12(subgame12.status);
        setSubgame13(subgame13.status);
      });
  }, [activeTab])

  return (
    <>
      <div className="main_page silang">
        <div className="main_nav-tabwrapper">
          {(subgame12 === 0 || subgame13 === 0) ? '' :
            <div
              className={`main_tab ${activeTab === 1 ? "active" : ""}`}
              onClick={() => handleTabClick(1)}
            >
              Silang / Homo
            </div>
          }
          {(subgame12 === 0 || subgame13 === 0) ? '' :
            <div
              className={`main_tab ${activeTab === 2 ? "active" : ""}`}
              onClick={() => handleTabClick(2)}
            >
              Kembang / Kempis
            </div>
          }
        </div>
        <div className="maintabcontent-wrapper">
          {activeTab === 1 && (
            (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
              <div>
                {app_type === 'wap' ? (
                  <SilangVersiWap />
                ) : (
                  <Silang />
                )}
              </div>
            )
          )}
          {activeTab === 2 && (
            (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
              <div>
                {app_type === 'wap' ? (
                  <KembangVersiWap />
                ) : (
                  <Kembang />
                )}
              </div>
            )
          )}
        </div>
      </div>
    </>
  )
}

export default withTranslation()(SilangKembang)